import { render, staticRenderFns } from "./LastModifiedBy.vue?vue&type=template&id=a1a7cd9a"
import script from "./LastModifiedBy.vue?vue&type=script&lang=js"
export * from "./LastModifiedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports